// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2m9ky","label":"Section_label__2KKzC","contentWrap":"Section_contentWrap__3JZuq","footer":"Section_footer__eaVmL","footerInner":"Section_footerInner__pzMlE"};